import { LoadingButton } from "@mui/lab";
import { Button, DialogActions, DialogContent, Typography } from "@mui/material";
import { ConversationFolder } from "@rms-types/modules/conversation-folder/entities/conversation-folder";
import { paths } from "@rms-types/constants/paths";
import { useLocation, useNavigate } from "react-router";

import { useDeleteConversationFolder } from "@/features";
import { useDashboardSidebarStore, useModalStore } from "@/hooks";

export function useDeleteConversationFolderConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    actions: { refetchConversationSidebar },
  } = useDashboardSidebarStore();

  const { pushModal, popModal } = useModalStore((state) => state.actions);

  const { deleteConversationFolder, isDeleteConversationFolderPending } = useDeleteConversationFolder({
    onSuccess: (_, variables) => {
      popModal();
      refetchConversationSidebar();
      if (variables.id && location.pathname.includes(paths.app.messages.folder.details.getLink(variables.id))) {
        navigate(paths.app.messages.getLink());
      }
    },
  });

  const handleDelete = (conversationFolder: ConversationFolder) => {
    pushModal({
      title: `Delete ${conversationFolder.name}`,
      maxWidth: "xs",
      content: (
        <>
          <DialogContent>
            <Typography gutterBottom>
              Are your sure you want to delete the folder <strong>{conversationFolder.name}</strong>?
            </Typography>
            <Typography variant="caption">
              <i>Note: This will also delete the messages inside this folder.</i>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => popModal()}>Cancel</Button>
            <LoadingButton
              variant="contained"
              color="error"
              onClick={() => deleteConversationFolder({ id: conversationFolder.id })}
              loading={isDeleteConversationFolderPending}
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </>
      ),
    });
  };

  return {
    isDeleteConversationFolderPending,
    handleDelete,
  };
}
